
import { Vue } from "vue-class-component"; // 基本需要
import {
  dispatchGetGamesDate,
  dispatchGetGamesSubscription,
  dispatchGetProjects,
  dispatchGetGamesData,
  dispatchGetGamesTap,
} from "@/store/project/actions";
import { dispatchUploadGamesReportImage } from "@/store/performance/actions";
import { readUserProfile } from "@/store/main/getters";
import { readtestGamesDate, readtestGamesData } from "@/store/project/getters";
import { dateConversion } from "@/utils"; //类型
import { store } from "@/store";
import { getLocalProject } from "@/utils";
import "@/assets/iconfont/font_3410179_5uqi6h3hn2r/iconfont.css"; //引入仓库
export default class GamesNew extends Vue {
  public localProject = Number(getLocalProject());
  public text = "";
  public dialogAddFormVisible = false;
  public resetAddForm(formName: any) {
    this.dialogAddFormVisible = false;
  }
  public backShow = false;
  public formMail = {
    title: "", //标题
    Sender: "gamerobot@tencent.com", //发件人
    addressee: "", //收件人
    CC_List: "", //抄送人
  };
  public skey = "";
  public p_skey = "";
  public date = "";
  public edit = false;
  public sendOut() {
    this.edit = !this.edit;
  }
  public autoAdd() {
    this.formMail.title =
      this.type == "2"
        ? "外部新游榜监控(" + this.getCurrentDate + ")"
        : "腾讯新游预约榜(" + this.getCurrentDate + ")双平台";
    this.formMail.addressee =
      this.type == "2"
        ? "fionayan@tencent.com;georgezhang@tencent.com;johnxiao@tencent.com;kernzhou@tencent.com;sheldonwang@tencent.com;zhanglongluo@tencent.com;nakewang@tencent.com"
        : "fionayan@tencent.com;georgezhang@tencent.com;johnxiao@tencent.com;kernzhou@tencent.com;sheldonwang@tencent.com;zhanglongluo@tencent.com;nakewang@tencent.com";
    this.formMail.CC_List =
      this.type == "2"
        ? "G_IEG_QM_CD_team3@tencent.com;"
        : "G_IEG_QM_CD_team3@tencent.com;G_IEG_QM_CD_team2@tencent.com;G_IEG_QM_SR@tencent.com;brucewei@tencent.com;aaronwu@tencent.com;xianluo@tencent.com;linnyang@tencent.com;bellajwang@tencent.com";
  }
  public get getCurrentDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  public save_report() {
    let upload_data = {
      project: this.localProject,
      title: this.formMail.title,
      recv: this.formMail.addressee,
      cc: this.formMail.CC_List,
      send: this.formMail.Sender,
      date: this.date,
      last: this.old_date,
      url: window.location.href,
      type: Number(this.type),
    };
    dispatchUploadGamesReportImage(store, upload_data);
  }
  public tableLoading = false;
  public get dataList() {
    let list = [];
    if (this.type == "0") {
      list = ["wechat", "qq"];
    } else if (this.type == "1") {
      list = ["list", "change_list"];
    } else {
      list = ["预约榜", "Tap游戏热搜"];
    }
    return list;
  }
  public get gamesData() {
    let list: any = {};
    list = readtestGamesData(store);
    list.wechat_time = this.time(list.wechat_time);
    list.qq_time = this.time(list.qq_time);
    return list;
  }
  public time(dateTimeString?) {
    // 将日期和时间字符串转换为Date对象

    if (dateTimeString) {
      let date = new Date(
        dateTimeString.replace(
          /(\d{4})-(\d{2})-(\d{2}) (\d{2})-(\d{2})-(\d{2})/g,
          "$1/$2/$3 $4:$5:$6"
        )
      );

      // 使用toISOString()方法将Date对象转换为ISO格式的日期和时间字符串
      return dateConversion(date);
    }
  }
  public getDescription(type, item) {
    if (type == 0) {
      return item === "qq" ? "手Q" : "微信";
    } else if (type == "1") {
      return "微信+手Q双平台";
    } else if (type == "2") {
      // 根据需要增加更多的类型处理
      // 例如 type 为 1 和其他情况的处理逻辑
      return "TapTap"; // 默认值或根据 type 和 item 处理的值
    }
  }

  public type = "1";
  public type_list = [
    { label: "双平台", value: "1" },
    { label: "微信/手Q", value: "0" },
    { label: "TapTap", value: "2" },
  ];
  public getIcon(num) {
    if (num == 0) {
      return "t-icon t-icon-jinpai";
    } else if (num == 1) {
      return "t-icon t-icon-yinpai";
    } else if (num == 2) {
      return "t-icon t-icon-tongpai";
    }
  }
  public get_is_super(flag) {
    if (this.type == "2") {
      if (flag) {
        return true;
      } else {
        return false;
      }
    } else {
      let name = [
        "pagezhang",
        "v_baofeiyan",
        "v_yihuideng",
        "febechen",
        "v_zbdeng",
      ];
      if (name.includes(readUserProfile(store).username)) {
        return true;
      } else {
        return false;
      }
    }
  }
  public get autoBtnShow() {
    let name = ["pagezhang", "v_baofeiyan", "v_yihuideng"];
    if (name.includes(readUserProfile(store).username)) {
      return true;
    } else {
      return false;
    }
  }
  public url = "";
  // public mounted(){

  //      dispatchGetGamesSubscription(store, { url: 'https://game.weixin.qq.com/cgi-bin/gamewap/getnewgamelist?key=fa5bca61f74cc15624a3bf71e5864d90cc9f23572f4c7bdd170bb02ebf6730ad054f1d76f33685d43d2aeaf30545a3477f6e25f027d47ea4a9594a80efb13dcc2f06ec44b01ebcc92bb42e981605f83c2236fb2d9291e50fb18ae624f3fd07bf2e4ed9a0ef4754c375a13bf8afa79fe6293f6450363f6e131548f49077544bc7&uin=MzMwNjU4Mzk0Mw%3D%3D&exportkey=n_ChQIAhIQ%2FtdnGAE7t61hs%2BbfUFS77xLQAQIE97dBBAEAAAAAAHGLIcxaHU0AAAAOpnltbLcz9gKNyK89dVj0yy3BYHr5glxMKxf%2BDvMfLwixKN5A5%2BYIGkoKUd5obaQirPozPJsTpPePXh4d%2BjoYfHbimutfgALH8QYdaK8vrH6lwr2uED7DaL4dyadku7X5Aa9Hem9izPTJo7d%2F0Xcp2M6DDOKQBg%2BidrrerP9FopIOtBhdiloNSjz6E9fM9u6uXnvaRCbRLBo1E2%2FYj1wh2OuX4ELDAPC0Nlx%2FNJG58A7fPpKhcOk6ubQ%3D&pass_ticket=qVWWWvuW0Bk8bBTRhORwdBK6RZToxhWjGPCOI5LCUT%2F3ZzHLS4Ki1wyzPNQ7Ep4X&wx_header=1' });
  // }
  public findClosestDate(
    arr: { date: string }[],
    selectedDate: string
  ): string {
    const targetDate: any = new Date(selectedDate);
    targetDate.setDate(targetDate.getDate() - 1);
    let closestDate = null;
    let minDiff = Number.MAX_VALUE;

    arr.forEach((item) => {
      const currentDate: any = new Date(
        item.date.replace(/-/g, (match, offset, string) => {
          return offset === 4 || offset === 7 ? "-" : ":";
        })
      );
      const diff = Math.abs(currentDate - targetDate);
      if (
        currentDate.toDateString() === targetDate.toDateString() &&
        diff < minDiff
      ) {
        closestDate = item.date;
        minDiff = diff;
      }
    });

    return closestDate || "";
  }
  public get headerCellStyle() {
    return {
      background: this.type == "2" ? "#bbb4e9" : "#FFF0F0",
      color: "black",
      fontWeight: "bold",
      textAlign: "center",
    };
  }
  public convertDateFormats(arr) {
    return arr.map((item) => {
      const dateParts = item.date.split(" ");
      const timeParts = dateParts[1].split("-");
      const formattedTime = timeParts.join(":");
      return { date: dateParts[0] + " " + formattedTime };
    });
  }
  findIndexOfDate(list, searchString) {
    for (let i = 0; i < list.length; i++) {
      let currentItem = list[i];

      if (currentItem.date.toString() === searchString) {
        return i;
      }
    }

    return -1;
  }
  public date_text = "";
  public async dateOldChange() {
    this.tableLoading = true;
    this.backShow = true;
    if (this.old_date) {
      if (
        this.findClosestDate(this.date_options, this.date).split(" ")[0] ==
        this.old_date.split(" ")[0]
      ) {
        this.date_text = "昨日";
      } else {
        this.date_text = "对比" + this.old_date.split(" ")[0];
      }
    }
    let b = (this as any).$message({
      //Message 消息提示
      message: "数据获取中,请稍等...",
      showClose: true,
      duration: 0,
    });

    //  this.old_date= this.findClosestDate(this.date_options,this.date)? this.findClosestDate(this.date_options,this.date):(this.date_options[this.findIndexOfDate(this.date_options,this.date)+1]?.date?this.date_options[this.findIndexOfDate(this.date_options,this.date)+1]?.date:'')

    // this.old_record_id_created()
    await dispatchGetGamesData(store, {
      date: this.date,
      last: this.old_date,
      type: Number(this.type),
    });
    b.close();
    this.backShow = false;
    this.tableLoading = false;
  }
  public async dateChange(flag) {
    this.tableLoading = true;
    this.backShow = true;
    if (flag) {
      await dispatchGetGamesDate(store, {
        type: Number(this.type),
      });
      this.date = this.date_options[0].date;
    }

    let b = (this as any).$message({
      //Message 消息提示
      message: "数据获取中,请稍等...",
      showClose: true,
      duration: 0,
    });
    if (this.findClosestDate(this.date_options, this.date)) {
      this.old_date = this.findClosestDate(this.date_options, this.date);
      this.date_text = "昨日";
    } else {
      if (
        this.date_options[
          this.findIndexOfDate(this.date_options, this.date) + 1
        ]
      ) {
        this.old_date = this.date_options[
          this.findIndexOfDate(this.date_options, this.date) + 1
        ].date;
        this.date_text = "对比" + this.old_date.split(" ")[0];
      } else {
        this.old_date = "";
        this.date_text = "-";
      }
    }
    //  this.old_date= this.findClosestDate(this.date_options,this.date)? this.findClosestDate(this.date_options,this.date):(this.date_options[this.findIndexOfDate(this.date_options,this.date)+1]?.date?this.date_options[this.findIndexOfDate(this.date_options,this.date)+1]?.date:'')

    // this.old_record_id_created()
    await dispatchGetGamesData(store, {
      date: this.date,
      last: this.old_date,
      type: Number(this.type),
    });
    b.close();
    this.backShow = false;
    this.tableLoading = false;
  }

  public async mounted() {
    this.tableLoading = true;
    await dispatchGetGamesDate(store, {
      type: Number(this.type),
    });
    if (this.date_options?.length > 0) {
      this.date = this.date_options[0].date;
      if (this.findClosestDate(this.date_options, this.date)) {
        this.old_date = this.findClosestDate(this.date_options, this.date);
        this.date_text = "昨日";
      } else {
        if (
          this.date_options[
            this.findIndexOfDate(this.date_options, this.date) + 1
          ]
        ) {
          this.old_date = this.date_options[
            this.findIndexOfDate(this.date_options, this.date) + 1
          ].date;
          this.date_text = "对比" + this.old_date.split(" ")[0];
        } else {
          this.old_date = "";
          this.date_text = "-";
        }
      }
      await dispatchGetGamesData(store, {
        date: this.date,
        last: this.old_date,
        type: Number(this.type),
      });
    } else {
      return;
    }
    this.tableLoading = false;
  }
  public async tapClick() {
    this.tableLoading = true;
    this.backShow = true;
    let b = (this as any).$message({
      //Message 消息提示
      message: "数据获取中,请稍等...",
      showClose: true,
      duration: 0,
    });
    await dispatchGetGamesTap(store);
    await dispatchGetGamesDate(store, {
      type: Number(this.type),
    });
    this.date = this.date_options[0].date;
    if (this.date_options?.length > 0) {
      this.date = this.date_options[0].date;
      if (this.findClosestDate(this.date_options, this.date)) {
        this.old_date = this.findClosestDate(this.date_options, this.date);
        this.date_text = "昨日";
      } else {
        if (
          this.date_options[
            this.findIndexOfDate(this.date_options, this.date) + 1
          ]
        ) {
          this.old_date = this.date_options[
            this.findIndexOfDate(this.date_options, this.date) + 1
          ].date;
          this.date_text = "对比" + this.old_date.split(" ")[0];
        } else {
          this.old_date = "";
          this.date_text = "-";
        }
      }
      await dispatchGetGamesData(store, {
        date: this.date,
        last: this.old_date,
        type: Number(this.type),
      });
    }
    b.close();
    this.backShow = false;
    this.tableLoading = false;
  }
  public async submitAddForm() {
    this.tableLoading = true;
    this.backShow = true;
    this.dialogAddFormVisible = false;
    let b = (this as any).$message({
      //Message 消息提示
      message: "数据获取中,请稍等...",
      showClose: true,
      duration: 0,
    });
    await dispatchGetGamesSubscription(store, {
      url: this.url,
      p_skey: this.p_skey,
      skey: this.skey,
    });
    await dispatchGetGamesDate(store, {
      type: Number(this.type),
    });
    this.date = this.date_options[0].date;
    this.type = "1";
    if (this.findClosestDate(this.date_options, this.date)) {
      this.old_date = this.findClosestDate(this.date_options, this.date);
      this.date_text = "昨日";
    } else {
      if (
        this.date_options[
          this.findIndexOfDate(this.date_options, this.date) + 1
        ]
      ) {
        this.old_date = this.date_options[
          this.findIndexOfDate(this.date_options, this.date) + 1
        ].date;
        this.date_text = "对比" + this.old_date.split(" ")[0];
      } else {
        this.old_date = "";
        this.date_text = "-";
      }
    }
    await dispatchGetGamesData(store, {
      date: this.date,
      last: this.old_date,
      type: Number(this.type),
    });

    b.close();
    this.backShow = false;
    this.tableLoading = false;
  }
  public old_date = "";
  public get date_options() {
    return this.convertDateFormats(readtestGamesDate(store));
  }
  public old_record_id_created() {
    let num = 0;
    if (this.date_options.length > 1) {
      if (this.date_options[this.date_options.length - 1].date == this.date) {
        this.date_options.forEach((v, index) => {
          if (v.date == this.date) {
            num = index;
          }
        });
        this.old_date = "";
      } else {
        this.date_options.forEach((v, index) => {
          if (v.date == this.date) {
            num = index;
          }
        });
        this.old_date = this.date_options[num + 1].date;
      }
      // this.perfDateOptions.forEach((v,index)=>{
      //   if(v.task_record_id==this.task_id){
      //     num=index
      //   }
      // })
      // if(num==(this.perfDateOptions.length-1)){

      // }
    } else {
      this.old_date = this.date_options[0].date;
    }
  }
}
